import type { AnswerMap, BrsrQuestion, VisibilityRule } from '../../data/brsr/types'

export function ruleMatches(responses: AnswerMap, rule: VisibilityRule): boolean {
  const value = responses[rule.questionId]
  if (rule.equals === undefined) return false
  const allowed = Array.isArray(rule.equals) ? rule.equals : [rule.equals]
  if (Array.isArray(value)) return value.some((item) => allowed.includes(item))
  return typeof value === 'string' && allowed.includes(value)
}

export function isQuestionVisible(question: BrsrQuestion, responses: AnswerMap): boolean {
  const visibility = question.visibility
  if (!visibility) return true
  if (visibility.all && !visibility.all.every((rule) => ruleMatches(responses, rule))) return false
  if (visibility.any && !visibility.any.some((rule) => ruleMatches(responses, rule))) return false
  if (visibility.none && visibility.none.some((rule) => ruleMatches(responses, rule))) return false
  return true
}

export function visibleQuestions(questions: BrsrQuestion[], responses: AnswerMap): BrsrQuestion[] {
  return questions.filter((question) => isQuestionVisible(question, responses))
}
